import styled from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/toyotaTheme";

export const Wrapper = styled.ul`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    column-gap: var(--spacing-1);
    row-gap: var(--spacing-2);
    padding: var(--spacing-3);
    list-style: none;
    border: 1px solid var(--color-grey-6);

    li {
        display: flex;
        align-items: flex-start;
        justify-content: space-between;
        margin: 0;
        padding: 0;
        font-family: var(--font-regular);
        font-size: 1.3rem;
        line-height: 2rem;
        color: var(--color-primary-black);
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        grid-template-columns: repeat(4, 1fr);

        li {
            font-size: 1.4rem;
        }
    }

    @supports not (padding-inline: 0) {
        grid-column-gap: var(--spacing-1);
        grid-row-gap: var(--spacing-2);
    }
`;

export const SpecWrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: space-between;
    width: 100%;
`;

export const SpecValueWrapper = styled.div`
    display: flex;
    align-items: center;
    gap: calc(var(--spacing-1) / 2);
    margin-top: calc(var(--spacing-1) / 2);

    @supports not (gap: 0) {
        > *:not(:last-child) {
            margin-right: calc(var(--spacing-1) / 2);
        }
    }
`;
